export default function initUnderlineScale() {
  const underlineHolders = document.querySelectorAll('.underline-scale');
  if (underlineHolders.length === 0) return;

  const activeClass = 'active';
  const animatedItems = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      // filter only intersecting and not yet animated items
      const newEntries = entries.filter(entry => entry.isIntersecting && !animatedItems.has(entry.target));

      newEntries.forEach((entry, index) => {
        const delay = index * 1000 // 1s stagger delay
        setTimeout(() => {
          entry.target.classList.add(activeClass);
          animatedItems.add(entry.target);
        }, delay);
      })
    },
    {
      threshold: 1,
    }
  );

  underlineHolders.forEach((underlineHolder) => observer.observe(underlineHolder));
}
